import { Head } from '@inertiajs/react'
import type { Organization } from '@/types'
import { Button } from '@/components/ui/Button'
import { Card } from '@/components/ui/Card'
import { Pill } from '@/components/ui/Pill'

type Member = {
  id: number
  role: string
  email_address: string
}

type Labels = {
  members_heading: string
  edit_cta: string
  roles: Record<string, string>
}

type Props = {
  organization: Organization
  members: Member[]
  labels: Labels
}

export default function OrganizationShow({ organization, members, labels }: Props) {
  return (
    <>
      <Head title={organization.name} />
      <div className="mx-auto max-w-3xl px-4 py-10 sm:px-6 lg:px-8">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h1 className="font-display text-3xl text-ink">{organization.name}</h1>
            <p className="mt-1 text-sm text-ink-faint">{organization.slug}</p>
          </div>
          <Button variant="ghost" href={`/organizations/${organization.slug}/edit`} className="shrink-0">
            {labels.edit_cta}
          </Button>
        </div>

        <section className="mt-10">
          <h2 className="mb-4 font-display text-xl text-ink">{labels.members_heading}</h2>
          <Card className="overflow-hidden">
            <ul>
              {members.map((member) => (
                <li
                  key={member.id}
                  className="flex items-center justify-between gap-4 border-t border-line px-5 py-3.5 first:border-t-0"
                >
                  <span className="text-sm text-ink">{member.email_address}</span>
                  <Pill tone={member.role === 'owner' ? 'flame' : 'ink'}>{labels.roles[member.role] ?? member.role}</Pill>
                </li>
              ))}
            </ul>
          </Card>
        </section>
      </div>
    </>
  )
}
